<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">All Invoices</h4>
                                <h6 class="card-subtitle">Search invoices by status, customer</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link
                                                :to="{name: 'addmarketplaceinvoice', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Invoice
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-4">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('partner')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="buyers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchBuyers"
                                            class="form-control multiselect-sm"
                                            data-vv-as="buyer"
                                            id="buyer"
                                            label="buyer"
                                            name="buyer"
                                            open-direction="bottom"
                                            placeholder="Search Buyer"
                                            track-by="id"
                                            v-if="currentOrg.type === 'COOP'"
                                            v-model="filter.buyer"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.biz_name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.biz_name }}</h5>
                                                    <div>{{ props.option.biz_name }}</div>
                                                    <div>{{ props.option.biz_email }}</div>
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :max-height="600"
                                            :options="sellers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            @search-change="searchSellers"
                                            class="form-control  multiselect-sm"
                                            id="seller"
                                            label="seller"
                                            name="seller"
                                            open-direction="bottom"
                                            placeholder="Search Seller"
                                            v-if="currentOrg.type === 'COOP_MEMBER'"
                                            v-model="filter.seller">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Seller not found</span>
                                    </multiselect>
                                </div>
                                <div class="col-4">
                                    <select class="custom-select" id="inlineFormCustomSelect"
                                            v-model="filter.status">
                                        <option :value="null">Choose Status</option>
                                        <option
                                                v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in statuses">{{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-4">
                                    <input
                                            class="form-control"
                                            name="purchase"
                                            placeholder="Invoice #"
                                            type="text"
                                            v-model="filter.invoiceid">
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-2">
                                    <input class="form-control" id="startdate" placeholder="Start Date" type="text"/>
                                </div>
                                <div class="col-2">
                                    <input class="form-control" id="enddate" placeholder="End Date" type="text"/>
                                </div>
                                <div class="col-2">
                                    <div class="btn-group" style="display: flex;">
                                        <button @click="searchInvoice(1)"
                                                class="btn btn-light btn-outline-success font-weight-bold"
                                                style="flex: 1"
                                                type="button">
                                            <i class="fa fa-search"/> Go!
                                        </button>
                                        <button @click="reset()"
                                                class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                                style="flex: 1" type="button">
                                            <i class="fa fa-undo"/> Reset
                                        </button>
                                    </div>
                                </div>
                                <div class="col-2 text-right ml-auto">
                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" title="Exporting, please wait ..."
                                      v-if="exporting">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                    <button aria-expanded="false" aria-haspopup="true"
                                            class="btn waves-effect waves-light btn-outline-info"
                                            data-toggle="dropdown" title="Operations">
                                        <i class="fa fa-grip-vertical"/>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="javascript:void(0)">
                                            <json-c-s-v
                                                    :data="exportedInvoice"
                                                    :name="'Invoice Report.csv'">
                                                Export as CSV
                                            </json-c-s-v>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group row">
                            <label class="col-form-label p-l-10" for="records">Display</label>
                            <div class="col-sm-1 p-t-5">
                                <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                        class="form-control form-control-sm" id="records" name="lang_opt_length"
                                        v-model="perPage">
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <label class="col-form-label" for="records">Records per page</label>

                            <div class="ml-auto p-r-10">
                                <select aria-controls="lang_opt"
                                        class="form-control form-control-sm" id="flag" name="lang_opt_length"
                                        v-model="flagged">
                                    <option :value="null">All</option>
                                    <option value="Flagged">Flagged</option>
                                    <option value="Matched">Matched</option>
                                    <option value="Mismatched">Mismatched</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive m-t-30" v-if="invoices.length>0">
                        <table class="table no-wrap v-middle">
                            <thead>
                            <tr class="border-0">
                                <th class="border-0"><h6></h6></th>
                                <th class="border-0"><h6>Status</h6></th>
                                <th class="border-0"><h6>Number</h6></th>
                                <th class="border-0"><h6>Customer</h6></th>
                                <th class="border-0"><h6>Total</h6></th>
                                <th class="border-0"><h6>Due At</h6></th>
                                <th class="border-0"><h6>Actions</h6></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-bind:key="index" v-for="(inv, index) in invoices">
                                <td class="starred">
                                    <i class="fas fa-lg fa-check-circle text-dark-green" v-if="inv.flagging_status === 'Matched'"></i>
                                    <i class="fas fa-lg fa-exclamation-circle text-warning" v-else-if="inv.flagging_status === 'Mismatched'"></i>
                                    <i class="fas fa-lg fa-flag text-danger" v-else-if="inv.flagging_status === 'Flagged'"></i>
                                </td>
                                <td>
                                    <p v-if="inv.status === 'DRAFT'"><span class="label label-cyan">Draft</span></p>
                                    <p v-else-if="inv.status === 'VOID'"><span class="label label-brown">Void</span></p>
                                    <p v-else-if="inv.status === 'SENT'"><span class="label label-primary">Sent</span></p>
                                    <p v-else-if="inv.status === 'WRITE-OFF'"><span
                                            class="label label-warning">Write-Off</span></p>
                                    <p v-else-if="inv.status === 'RECORD_PAYMENT'"><span class="label label-light-green">Payment Recorded</span>
                                    </p>
                                    <p v-else-if="inv.status === 'PAID'"><span class="label label-dark-green">Paid</span></p>
                                </td>
                                <td>{{inv.invoice_number}}</td>
                                <td>{{inv.buyer.biz_name | capitalize}}</td>
                                <td>{{inv.total | money}}</td>
                                <td>{{inv.due_at | medium}}</td>
                                <td>
                                    <router-link
                                            :to="{'name': 'viewmarketplaceinvoice', 'params': {invoiceid: inv.id}}">
                                        <i class="fas fa-eye m-10"></i>
                                    </router-link>
                                    <router-link :to="{'name': 'editmarketplaceinvoice', 'params': {invoiceid: inv.id}}"
                                                 v-if="inv.status === 'DRAFT'">
                                        <i class="fas fa-pencil-alt text-primary"></i>
                                    </router-link>
                                    <i @click="setRemoveProps(inv.id)" class="far fa-trash-alt text-danger m-l-10"
                                       data-target="#confirmModal" data-toggle="modal" style="cursor: pointer"
                                       v-if="inv.status === 'DRAFT'"></i>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- MODAL FOR CONFIRMATION -->
                        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal"
                             role="dialog" tabindex="-1">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-body card-blue">
                                        <div class="text-center m-t-20 m-b-10">
                                            <i class="fa fa-exclamation-triangle text-warning"
                                               style="font-size:50px"></i>
                                            <br><br>
                                            <h4>Are you sure you want to remove this invoice?</h4>
                                            <button @click="removeInvoice"
                                                    class="btn waves-effect waves-light btn-success m-r-15"
                                                    data-dismiss="modal" type="button">Yes
                                            </button>
                                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal"
                                                    type="button">No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-else>
                        <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                        <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                    </template>

                </div>
            </div>
        </div>
        <div class="row" v-if="invoices.length > 0">
            <div class="col-6 offset-6">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import JsonCSV from 'vue-json-csv';
    import XLSX from "xlsx";

    export default {
        name: "Invoices",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Multiselect, Paginate, JsonCSV},
        watch: {
            flagged: function (nv, ov) {
                if (nv !== ov) {
                    this.getInvoices(1)
                }
            }
        },
        data() {
            return {
                submitted: false,
                isLoading: false,
                statuses: ['DRAFT', 'VOID', 'SENT', 'PAID'],
                buyers: [],
                sellers: [],
                filter: {
                    buyer: null,
                    seller: null,
                    status: null,
                    fromDate: "",
                    toDate: "",
                    invoiceid: null
                },
                buyer: null,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                invoices: [],
                pageCount: 1,
                total: 0,
                opens: 'right',
                value: true,
                exportedInvoices: [],
                inv_export_name: "Invoice_Report.csv",
                perPage: 10,
                isFiltered: false,
                removeInvoiceId: null,
                exporting: false,
                exportedInvoice: [],
                flagged: null
            }
        },
        mounted() {
            this.init();
            let self = this;
            $(function () {
                $('#startdate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.fromDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.fromDate = null;
                        }
                    });

                $('#enddate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.toDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.toDate = null;
                        }
                    });
            });
        },
        methods: {
            async init() {
                await this.getInvoices(1);
            },
            perPageRecordChange() {
                if (this.isFiltered) {
                    this.searchInvoice(1);
                } else {
                    this.getInvoices(1);
                }
            },
            async getInvoices(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/invoices`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            flagging_status: this.flagged
                        }
                    });
                    $(".preloader").fadeOut();

                    this.isFiltered = false;
                    this.total = reply.data.total;
                    this.invoices = reply.data.invoices;
                    this.exportedInvoice = reply.data.invoices.map(s => ({
                        number: s.invoice_number,
                        status: s.status,
                        seller: s.seller.biz_name,
                        buyer: s.buyer.biz_name,
                        total: s.total.currency_symbol + ' ' + s.total.amount,
                        created_at: moment(s.created_at).format("MMMM Do YYYY")
                    }))
                    let max_date = reply.data.min_date;
                    let min_date = reply.data.max_date;
                    if (min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate = moment(min_date).format('YYYY-MM-DD');
                    } else if (this.invoices.length === 1) {
                        this.startDate = moment(this.invoices[0].created_at).format('YYYY-MM-DD');
                        this.endDate = moment(this.invoices[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.setPageCount();
                } catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getInvoices(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            change(e) {
                this.filter.fromDate = e[0].toDate();
                this.filter.toDate = e[1].toDate();
            },
            async searchBuyers(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/invoices/buyer/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.buyers = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchSellers(searchText) {
                try {
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/sales/seller/search`, {
                            params: {
                                search: searchText
                            }
                        });
                    this.sellers = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            selectBuyer() {
                this.filter.buyer_id = this.buyer.id;
            },
            async searchInvoice(page) {
                try {
                    this.filter.buyer = this.filter.buyer ? this.filter.buyer : {};
                    this.filter.seller = this.filter.seller ? this.filter.seller : {};
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${JSON.stringify(this.filter)}/search`, {
                            params: {
                                page: page,
                                perPage: this.perPage
                            }
                        });
                    this.total = reply.data.total;
                    this.invoices = reply.data.invoices;
                    this.exportedInvoice = reply.data.invoices.map(s => ({
                        number: s.invoice_number,
                        status: s.status,
                        seller: s.seller.biz_name,
                        buyer: s.buyer.biz_name,
                        total: s.total.currency_symbol + ' ' + s.total.amount,
                        created_at: moment(s.created_at).format("MMMM Do YYYY")
                    }))
                    let max_date = reply.data.min_date;
                    let min_date = reply.data.max_date;
                    if (min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate = moment(min_date).format('YYYY-MM-DD');
                    } else if (this.invoices.length === 1) {
                        this.startDate = moment(this.invoices[0].created_at).format('YYYY-MM-DD');
                        this.endDate = moment(this.invoices[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.isFiltered = true;
                    this.setPageCount();
                } catch (e) {
                    console.log(e);
                }
            },
            async reset() {
                this.filter = {
                    buyer_id: null,
                    status: null,
                    fromDate: "",
                    toDate: "",
                    invoiceid: null
                };
                await this.init();
            },
            setRemoveProps(invoiceid) {
                this.removeInvoiceId = invoiceid;
            },
            async removeInvoice() {
                try {
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${this.removeInvoiceId}`);
                    this.$toastr('success', 'Invoiced deleted', 'Success');
                    await this.init();
                } catch (e) {
                    this.$toastr('error', e.response.data.reason, 'Failed');
                }
            },
            async exportInvoiceAsExcel() {
                try {
                    this.exporting = true;
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${JSON.stringify(this.filter)}/search`, {
                            params: {
                                page: 1,
                                perPage: this.perPage
                            }
                        });
                    let data = reply.data.invoices;
                    let invoices = [];
                    data.forEach(d => {
                        invoices.push({
                            "No": d.invoice_number,
                            "Status": d.status,
                            "Created At": moment(d.created_at, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm"),
                            "Due At": moment(d.due_at, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm"),
                            "Seller Name": d.seller.name,
                            "Seller Biz Name": d.seller.biz_name,
                            "Buyer Name": d.buyer.name,
                            "Buyer Biz Name": d.buyer.biz_name,
                            "Goods": this.getGoods(d.invoice_items),
                            "Total": d.total.currency_symbol + " " + Number(d.total.amount).toFixed(2)
                        })
                    });

                    let workbook = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(invoices);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices');
                    XLSX.writeFile(workbook, 'invoices.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            },
            getGoods(items) {
                let str = '';
                items.forEach(g => {
                    str = str + `${g.goods_services}(${g.amount.currency_symbol} ${g.amount.amount}/${g.unit}) - ${g.quantity} ${g.unit} \n`;
                });
                return str;
            }
        }
    }
</script>

<style scoped>

</style>
